import { ControlPanel, PaginationContainer, QueryParamsManager, SettingsRouter, Table } from "./components";
import style from "./MyProxiesPage.module.scss";

export function MyProxiesPage() {
  return (
    <main className={style.page}>
      <ControlPanel />
      <Table />
      <PaginationContainer />
      <QueryParamsManager />
    </main>
  );
}
